import { useState, useMemo } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from './components/AppBar';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Outlet } from 'react-router-dom';

import './App.css'
import { DrawerOpenContext } from './context/DrawerOpenContext';
import { LightDarkModeContext } from './context/LightDarkModeContext';

function App() {
  // Use light or dark theme depending on user's preference
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const [mode, setMode] = useState(prefersDarkMode ? 'dark' : 'light');
  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
      },
    }),
    [],
  );

  // make theme with either 'light' or 'dark' for the 'mode'.
  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode,
          primary: {
            main: mode === 'light' ? '#002768' : '#90caf9'
          }
        }
      }),
      [mode],
  );

  // hook for when drawer/sidebar is fully open or closed
  const [open, setOpen] = useState(false);

  // toggles when drawer/sidebar is fully open or closed
  const handleDrawer = () => {
    if (open) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  };

  return (
    <LightDarkModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {/* DrawerOpenContext is context for when drawer/sidebar is open or minimized.
        'Open' hook needs to be accessed by multiple child components */}
        <DrawerOpenContext.Provider value={open}>
          <div className="App">
            <AppBar handleDrawer={handleDrawer}/>
            {/* Outlet figures out which component/page to render based on index.js */}
            <Outlet />
          </div>
        </DrawerOpenContext.Provider>
      </ThemeProvider>
    </LightDarkModeContext.Provider>
  );
}

export default App;
